const configuredBackendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001';

const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1']);

export function resolveBackendUrl(backendUrl, browserHostname) {
  if (!LOCAL_HOSTS.has(browserHostname)) return backendUrl;
  try {
    const url = new URL(backendUrl);
    if (LOCAL_HOSTS.has(url.hostname)) url.hostname = browserHostname;
    return url.origin;
  } catch (error) {
    return backendUrl;
  }
}

export function getBackendUrl() {
  const browserHostname = typeof window === 'undefined' ? '' : window.location.hostname;
  return resolveBackendUrl(configuredBackendUrl, browserHostname);
}

export default getBackendUrl();
